import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StateOfTheEconomy from '../../collection-templates/state-of-the-economy';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import get from 'lodash/get';

const StateOfTheEconomyFullWidget = (props) => {
  const [collectionData, setCollectionData] = useState({});
  const queryClient = new QueryClient();

  useEffect(() => {
    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch(
            `https://www.ndtvprofit.com/api/v1/collections/${props?.slug}`,
          ).then((res) => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    };

    getCollectionData();
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');

    if (disabledm === "1") {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#FFFFFF";
    } else if (dm === "1" || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#2B2B2B";
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <StateOfTheEconomy collection={collectionData} widget={true} target="_parent" {...props} />
      )}
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => ({
  slug: get(
    state,
    ['qt', 'config', 'features', 'budget', 'state-of-the-economy-slug'],
    'fed-rate-cuts-story-since-lehman-crisis',
  ),
});

export default connect(mapStateToProps, {})(StateOfTheEconomyFullWidget);
